import { Box } from '@capitalise/ui-design-system';
import useChargebeeCheckout from '../../../hooks/useChargebeeCheckout';

const YourOrder = () => {
  const { iframeRef } = useChargebeeCheckout();

  return (
    <>
      <Box typography="heading-28">Your order</Box>
      <iframe ref={iframeRef} style={{ width: '450px', height: '70vh' }} />
    </>
  );
};

export default YourOrder;
